// extracted by mini-css-extract-plugin
var _1 = "BlockTestTimer_fireTime__c528d";
var _2 = "BlockTestTimer_icon__7f871";
var _3 = "BlockTestTimer_root__d4593";
export { _1 as "fireTime", _2 as "icon", _3 as "root" }
